import React, { useState } from 'react';
import '../css/animate.css';
import '../css/barvy.css';
import '../css/style.css';
import { useEffect } from 'react';
import { useRef } from 'react';
import builder from '../utils/builderWithLocale';
import { getLocalizedText } from '../utils/textLocalization';

function App({ setModal, tableId }) {
  const modalRef = useRef(null);
  const [tabulka, setTabulka] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setModal({ show: false, id: null });
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [setModal]);

  useEffect(() => {
    if (!tableId) {
      setTabulka({})
      return;
    }

    let cancelled = false;

    setLoading(true)
    setError(null)
    setTabulka({})

    // matchesQuery v editry/cms porovnává id, editryId i builder_id
    builder.get("velikostni-tabulky", {
      query: { id: tableId },
      limit: 1
    }).then(response => {
      if (cancelled) return;
      if (response && response.data) {
        setTabulka(response.data);
      } else {
        setError("Tabulka s daným ID nebyla nalezena.");
      }
    }).catch(err => {
      if (cancelled) return;
      console.error("Error fetching table:", err);
      setError("Chyba při načítání dat tabulky")
    }).finally(() => {
      if (!cancelled) setLoading(false);
    })

    return () => {
      cancelled = true;
    };
  }, [tableId])

  const handleClose = () => {
    setModal({ show: false, id: null })
  }

  return (
    <>
        <div className="modal-box">
            <div ref={modalRef}>
                <button onClick={handleClose}>{getLocalizedText('table.close')}</button>
                {loading && <p>{getLocalizedText('table.loading')}</p>}
                {error && <p style={{ color: 'red' }}>{error}</p>}

                {!loading && !error && tabulka.nazev && (
                  <>
                <h2>{tabulka.nazev}</h2>
                <table className="modal-table">
                    <thead>
                        <tr>
                            <th colSpan="2">{getLocalizedText('table.size')}</th>
                            <th>{getLocalizedText('table.height')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tabulka.velikosti && Array.isArray(tabulka.velikosti) ? (
                            tabulka.velikosti.map((element, index) => (
                                <tr key={index}>
                                    <td>{element.nazev}</td>
                                    <td>{element.velikost}</td>
                                    <td>{element.vyskaPostavy}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="3">{getLocalizedText('table.no_data')}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <h3>{getLocalizedText('table.disclaimer')}</h3>
                </>
                )}
            </div>
        </div>
    </>
  );
}

export default App;